import {createReducer} from '@reduxjs/toolkit'
import {EventsDates} from '@wix/wix-events-commons-statics'
import {changeEventAction} from '../actions/event'
import {getOccurrences} from '../actions/occurrences'

export interface OccurrencesState {
  events: wix.events.Event[]
  dates: {events: EventsDates}
  total: number
  loading: boolean
}

const defaultState: OccurrencesState = {
  events: [],
  dates: {events: {}},
  total: 0,
  loading: false,
}

export const occurrences = createReducer(defaultState, builder => {
  builder
    .addCase(getOccurrences.pending, state => ({...state, loading: true}))
    .addCase(getOccurrences.fulfilled, (state, action) => {
      const {events, dates, total} = action.payload

      return {
        loading: false,
        events: [...state.events, ...events],
        dates: {events: {...state.dates.events, ...dates.events}},
        total,
      }
    })
    .addCase(changeEventAction, () => defaultState)
})
